// What the dashboard (components/gift.js) does with the onboarding slider:
// "show" it, "mark-seen" (never show it again), "hide" it for now, or "none".
// fromStoreReady: the seller has just signed up - they left the Store Ready
// popup (Skip, Buy Plan or Add Products), or signed up with a plan and went
// through checkout. Only then does the story show (even if the store holds a
// sample product from before the popup stopped adding one). A seller who logs
// in to an existing account never sees it: "seen" lives in localStorage, which
// logout clears, so without this rule every login to a store with no products
// showed it again.
export const onboardingAction = ({ hasSeen, businessId, loading, productCount, fromStoreReady }) => {
    if (hasSeen) return "hide";
    if (loading) return "hide";
    if (!businessId) return "none";
    if (fromStoreReady) return "show";
    return productCount > 0 ? "mark-seen" : "hide";
};
